// FTR F19 — sheet tab bar

import type {ParsedSheet} from '@ts/mod/excel_gen/field_sheet_parse'
import {S} from './styles'

export function SheetTabs({sheets, onClickSheet}: {
	sheets: ParsedSheet[]
	onClickSheet: (name: string) => void
}) {
	return (
		<div style={S.sheetTabs}>
			{sheets.map(s => (
				<button
					key={s.name}
					style={{
						...S.sheetTab,
						borderBottomColor: s.tab_color ? `#${s.tab_color}` : '#ccc',
					}}
					onClick={() => onClickSheet(s.name)}
					title={`${s.name} — ${s.rows.length} rader`}
				>
					<span style={S.sheetTabName}>{s.name}</span>
					<span style={S.sheetTabCount}>{s.rows.length}</span>
				</button>
			))}
		</div>
	)
}
